import { Component, Input } from '@angular/core';

@Component({
	selector: 'qe-sidebar-infocard',
	templateUrl: './sidebar-infocard.component.html',
	styleUrls: ['./sidebar-infocard.component.scss'],
})
export class SidebarInfocardComponent {
	@Input() readonly heading: string = `Enter a heading`;
	@Input() headingBackground: string = `primary`;
	@Input() readonly headingColor: string = `primary`;

	constructor() { }
}
